import React from 'react';
import { format } from 'date-fns';

import './Header.scss';

interface HeaderProps {
  touramentName: string,
  country: string,
  teamMarkets: string,
  venue?: string,
  date: number,
  showHeader: boolean,
  type: string,
  sport?: string
}

function Header({ touramentName, country, teamMarkets, venue='', date, showHeader, type }: HeaderProps) {

  return (
    <div className="bet-header">
      {
        showHeader &&
      <div className="bet-header__tournament">
        { `${ touramentName }, ${ type === 'sport' ? '' : country }` }
      </div>
      }
      <div className="bet-header__markets-venue">
        <span className="bet-header__team-markets">{ teamMarkets }</span>
        <span className="bet-header__venue"> {
          venue ?
            `${ venue } | ${ format(date, 'dd/MM') } | ${ format(date, 'HH:mm') }` :
            `${ format(date, 'dd/MM') } | ${ format(date, 'HH:mm') }`
        }
        </span>
      </div>
    </div>
  );
}

export default Header;
